const SuccessMessage = ({msg, onClose, isVisible}) => {
    return isVisible && (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
            <strong>Success:</strong>{msg}
            <button type="button" className={"btn-close"} onClick={onClose}></button>
        </div>
    );
}

export default SuccessMessage